import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CHART_COLORS } from '../../utils/chartColors';

function monthLabel(ym) {
  const [year, month] = ym.split('-');
  return new Date(Number(year), Number(month) - 1, 1).toLocaleDateString('en-US', { month: 'short' });
}

function MonthlyTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-xl border border-gray-100 bg-white px-3 py-2.5 shadow-lg">
      <p className="text-xs font-medium text-gray-400">{label}</p>
      <div className="mt-1.5 space-y-1">
        {payload.map((p) => (
          <div key={p.dataKey} className="flex items-center gap-2 text-sm">
            <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: p.color }} />
            <span className="text-gray-500">{p.dataKey}</span>
            <span className="ml-auto pl-4 font-semibold text-gray-900">{p.value.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function MonthlyChart({ registrations, hires }) {
  const data = registrations.map((r, i) => ({
    month: monthLabel(r.month),
    Registrations: r.count,
    Hires: hires[i]?.count ?? 0,
  }));

  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} barGap={2} barCategoryGap="20%">
        <CartesianGrid strokeDasharray="0" vertical={false} stroke={CHART_COLORS.grid} />
        <XAxis dataKey="month" tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={{ stroke: CHART_COLORS.grid }} tickLine={false} />
        <YAxis allowDecimals={false} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
        <Tooltip cursor={{ fill: CHART_COLORS.ink, radius: 4 }} content={<MonthlyTooltip />} />
        <Legend
          iconType="circle"
          iconSize={8}
          wrapperStyle={{ fontSize: 13, color: CHART_COLORS.legend, paddingTop: 8 }}
        />
        <Bar
          dataKey="Registrations"
          fill={CHART_COLORS.primary}
          radius={[4, 4, 0, 0]}
          maxBarSize={24}
          activeBar={{ fillOpacity: 0.85 }}
        />
        <Bar
          dataKey="Hires"
          fill={CHART_COLORS.secondary}
          radius={[4, 4, 0, 0]}
          maxBarSize={24}
          activeBar={{ fillOpacity: 0.85 }}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
